export default __webpack_public_path__ + "static/media/GHSI Anti-Bribery Guidelines.e5a57b40.pdf";